
import { defineComponent, PropType } from 'vue';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridVue } from 'ag-grid-vue';
import { AG_GRID_LOCALE_EN, AG_GRID_LOCALE_FR, AG_GRID_LOCALE_NL } from '@ag-grid-community/locale';
import { saveGridState, loadGridState, applyStateToColumnDefs } from '@/utils/ag-grid-state';

export default defineComponent({
	name: 'RsltAgGrid',
	components: {
		AgGridVue
	},
	inheritAttrs: false,
	props: {
		gridKey: {
			type: String as PropType<string | null>,
			default: null
		},
		columnDefs: {
			type: Array as PropType<any[]>,
			required: true
		},
		rowData: {
			type: Array as PropType<any[]>,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: false
		},
		pagination: {
			type: Boolean,
			default: true
		},
		paginationPageSize: {
			type: Number,
			default: 25
		},
		paginationPageSizeSelector: {
			type: Array as PropType<number[]>,
			default: () => [10, 25, 50, 100]
		},
		gridClass: {
			type: [String, Array, Object] as PropType<string | string[] | Record<string, boolean>>,
			default: ''
		},
		suppressCellFocus: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			savedState: this.gridKey ? loadGridState(this.gridKey) : null
		};
	},
	computed: {
		agGridLocale() {
			const locales: Record<string, any> = {
				en: AG_GRID_LOCALE_EN,
				fr: AG_GRID_LOCALE_FR,
				nl: AG_GRID_LOCALE_NL
			};
			return locales[this.$i18n.locale] || AG_GRID_LOCALE_EN;
		},
		processedColumnDefs() {
			if (!this.gridKey || !this.savedState) {
				return this.columnDefs;
			}
			return applyStateToColumnDefs(this.columnDefs, this.savedState);
		}
	},
	methods: {
		onGridStateUpdated(event: any) {
			if (this.gridKey) {
				saveGridState(this.gridKey, event.state);
			}
		}
	}
});
